<template lang="pug">
div.wrap-module-edit-frame-by-drawing
  ItemDrawingSubHeader(:color="color" :strokeWeight="strokeWeight"
    :currentTool="currentTool"
    @setCurrentTool="setCurrentTool"
    @setColor="setColor" @setStrokeWeight="setStrokeWeight"
    @redo="redo" @undo="undo")
  div.wrap-drawing-canvas.f.fh.w-full
    canvas(ref="drawingCanvas"
      v-show="isInitialized"
      @mousedown="onCanvas($event)"
      @touchstart="onCanvas($event)"
      @mousemove="moveCanvas($event)"
      @touchmove="moveCanvas($event)"
      @mouseup="upCanvas($event)"
      @touchend="upCanvas($event)").drawing-canvas
    //- div(ref="drawingCanvas" :style="styleDrawingCanvas").drawing-canvas
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-module-edit-frame-by-drawing {
  .wrap-drawing-canvas {
    position: relative;
    padding-top: calc(#{$header_height} + #{$sub_header_height});
    height: $device_height;
    background: $secondary_bg_color;
    .drawing-canvas {
      position: relative;
      background: $primary_bg_color;
      touch-action: none;
    }
  }
}
</style>

<script>
import database from '@/database'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')
import ItemDrawingSubHeader from '@/components/item/ItemDrawingSubHeader'

export default {
  components: {
    ItemDrawingSubHeader
  },
  props: {
    frame: {
      type: Object,
      required: true
    },
    enableToSave: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapStateAuth(['uid']),
    styleDrawingCanvas () {
      return `
        width: ${this.paperSize.w}px;
        height: ${this.paperSize.h}px;
        `
    },
    canvas () {
      return this.$refs.drawingCanvas
    }
  },
  data () {
    return {
      isSaved: true, isInitialized: true,
      paperSize: { w: 1600, h: 1600 },
      frameImage: null, frameImageForPaper: null,
      isPushing: false,
      currentTool: 'pencil',
      color: '#000000',
      strokeWeight: 1,
      startPos: null,
      beforePos: null,
      histories: [], currentHistoryIndex: 0, maxHistoryNum: 100,
      undone: false, redone: false
    }
  },
  created () {
    window.addEventListener('beforeunload', this.confirmSave)
  },
  destroyed () {
    window.removeEventListener('beforeunload', this.confirmSave)
  },
  async beforeRouteLeave (to, from, next) {
    if (!this.isSaved){
      const answer = await window.customConfirm('編集中の内容は保存されませんが、よろしいですか？')
      answer ? next() : next(false)
    } else {
      next()
    }
  },
  async mounted () {
    if (this.frame.frameImg) {
      this.frameImage = await this.loadImage(this.frame.frameImg)
      await this.setPaperSize({ 
        w: this.frameImage.width, h: this.frameImage.height
      })
      const base64image = await this.resizeImage(this.frame.frameImg)
      this.frameImageForPaper = await this.loadImage(base64image, 'Anonymous')
      this.drawFrameImage()
    } else {
      await this.setPaperSize({ 
        w: this.frame.size.w, h: this.frame.size.h
      })
      const base64image = this.canvas.toDataURL()
      this.frameImageForPaper = await this.loadImage(base64image, 'Anonymous')
      this.drawFrameImage()
    }
    // console.log('this.frameImageForPaper:', this.frameImageForPaper)

    window.addEventListener('keydown', this.keydown)
    this.isInitialized = true
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.keydown)
  },
  methods: {
    onCanvas (event) {
      const e = event.changedTouches ? event.changedTouches[0] : event
      this.isPushing = true
      this.startPos = this.getPositionByEvent(e)
      this.beforePos = this.getPositionByEvent(e)

      // 前にredoされていたら今の履歴以降の履歴を削除
      if (this.redone) {
        this.histories = this.histories.splice(0, this.currentHistoryIndex + 1)
        this.redone = false
      }
      // 前にundoされていたら今の履歴以降の履歴を削除
      if (this.undone) {
        this.histories = this.histories.splice(0, this.currentHistoryIndex + 1)
        this.undone = false
      }
      // console.log('onCanvas', e)
    },
    moveCanvas (event) {
      if (!this.isPushing) return
      const e = event.changedTouches ? event.changedTouches[0] : event
      const pos = this.getPositionByEvent(e)
      if (pos.x <= 0 || this.paperSize.w <= pos.x
       || pos.y <= 0 || this.paperSize.h <= pos.y) {
        this.upCanvas(event)
        return
      }
      switch (this.currentTool) {
        case 'pencil':
          this.drawLine({
            from: this.beforePos, to: pos,
            color: this.color,
            lineWidth: this.strokeWeight
          })
          // if (this.strokeWeight <= 3) {
          //   this.drawLine({
          //     from: this.beforePos, to: pos,
          //     color: this.color,
          //     lineWidth: this.strokeWeight
          //   })
          // } else {
          //   this.drawCircle({
          //     pos,
          //     color: this.color,
          //     lineWidth: this.strokeWeight
          //   })
          // }
          break
        case 'straightLine':
          this.drawImageInHistories(this.histories.length - 1)
          this.drawLine({
            from: this.startPos, to: pos,
            color: this.color,
            lineWidth: this.strokeWeight
          })
          break
        case 'eraser':
          // this.clearByEraser({ pos, lineWidth: this.strokeWeight })
          this.drawLine({
            from: this.beforePos, to: pos,
            color: '#fff',
            lineWidth: this.strokeWeight * 2.0
          })
          break
      }
      this.beforePos = pos
      // console.log('moveCanvas', e)
    },
    async upCanvas (event) {
      // const e = event.changedTouches ? event.changedTouches[0] : event
      this.isPushing = false
      this.beforePos = null

      const currentBase64 = this.canvas.toDataURL()
      const currentImg = await this.loadImage(currentBase64, 'Anonymous')
      this.histories.push(currentImg)
      if (this.histories.length > this.maxHistoryNum) {
        this.histories = this.histories.splice(1, this.histories.length - 1)
      }
      this.currentHistoryIndex = this.histories.length - 1
      // console.log('this.histories', this.histories)

      this.$emit('activateSaveBtn')
      // console.log('upCanvas', e)
    },
    getPositionByEvent (e) {
      const boundingRect = this.canvas.getBoundingClientRect()
      return { 
        x: e.clientX - boundingRect.left,
        y: e.clientY - boundingRect.top
      }
    },
    drawLine ({ from, to, color, lineWidth }) {
      const ctx = this.canvas.getContext('2d')
      ctx.beginPath()
      ctx.moveTo(from.x, from.y)
      ctx.lineTo(to.x, to.y)
      ctx.strokeStyle = color
      ctx.lineWidth = lineWidth
      ctx.stroke()
      ctx.closePath()
    },
    drawCircle ({ pos, color, lineWidth }) {
      const ctx = this.canvas.getContext('2d')
      ctx.beginPath()
      ctx.arc(pos.x, pos.y, lineWidth, 0, Math.PI * 2, true)
      ctx.fillStyle = color
      ctx.fill()
      ctx.closePath()
    },
    clearByEraser ({ pos, lineWidth }) {
      const ctx = this.canvas.getContext('2d')
      ctx.clearRect(pos.x, pos.y, lineWidth * 2, lineWidth * 2)
    },
    // clearByEraser ({ pos, lineWidth }) {
    //   const ctx = this.canvas.getContext('2d')
    //   ctx.clearRect(pos.x, pos.y, lineWidth * 2, lineWidth * 2)
    // },
    drawImageInHistories (historyIndex) {
      const image = this.histories[historyIndex]
      const ctx = this.canvas.getContext('2d')
      ctx.clearRect(0, 0, image.width, image.height)
      ctx.drawImage(image,
        0, 0, image.width, image.height)
    },
    async setPaperSize (frameRect) {
      const maxPaperWidth = window.innerWidth < 800 ? 
        window.innerWidth : 800
      const headerHeight = 48
      const maxPaperHeight = (window.innerWidth - headerHeight) < 800 ?
        window.innerWidth - headerHeight : 800
      
      let resultW, resultH
      if (frameRect.w >= frameRect.h) {
        resultW = maxPaperWidth
        const scale = resultW / frameRect.w
        resultH = frameRect.h * scale
      } else {
        resultH = maxPaperHeight
        const scale = resultH / frameRect.h
        resultW = frameRect.w * scale
      }
      this.paperSize = { w: resultW, h: resultH }
      
      this.canvas.setAttribute('width', this.paperSize.w)
      this.canvas.setAttribute('height', this.paperSize.h)
    },
    drawFrameImage () {
      const ctx = this.canvas.getContext('2d')
      ctx.drawImage(this.frameImageForPaper,
        0, 0, this.frameImageForPaper.width, this.frameImageForPaper.height)
      this.histories.push(this.frameImageForPaper)
    },
    async keydown (e) {
      e.preventDefault()
      if ((e.ctrlKey && !e.metaKey) || (!e.ctrlKey && e.metaKey)) {
      // if (e.metaKey) {
        switch (e.key) {
          // redo
          case 'y':
            this.redo()
            break
          // undo
          case 'z':
            // 一番最初の履歴は残しておく
            this.undo()
            break
          // save
          case 's':
            if (this.enableToSave) this.$emit('onSave')
            break
          // reload
          case 'r':
          if (this.enableToSave) {
              // eslint-disable-next-line no-case-declarations
              const go = await window.customConfirm('ページを再読み込みしますか？*編集内容が保存されていません')
              if (go) location.reload()
            } else {
              location.reload()
            }
            break
        }
      }
    },
    redo () {
      if (this.currentHistoryIndex < this.histories.length - 1) {
        this.redone = true
        this.currentHistoryIndex++
        this.drawImageInHistories(this.currentHistoryIndex)
      }
    },
    undo () {
      if (this.currentHistoryIndex > 0) {
        this.undone = true
        this.currentHistoryIndex--
        this.drawImageInHistories(this.currentHistoryIndex)
      }
    },
    setCurrentTool (tool) {
      this.currentTool = tool
    },
    setColor (color) {
      this.color = color
    },
    setStrokeWeight (strokeWeight) {
      this.strokeWeight = strokeWeight
    },
    confirmSave (event) {
      if (!this.isSaved) {
        event.returnValue = '編集中の内容は保存されませんが、よろしいですか？'
      }
    },
    async resizeImage (imageToBeResized) {
      const image = await this.loadImage(imageToBeResized, 'Anonymous')
      
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')

      const THUMBNAIL_WIDTH = this.paperSize.w
      const THUMBNAIL_HEIGHT = this.paperSize.h
      
      let width, height, ratio
      if (image.width > image.height) {
        // 横長の画像は横のサイズを指定値にあわせる
        ratio = image.height / image.width
        width = THUMBNAIL_WIDTH
        height = THUMBNAIL_WIDTH * ratio
      } else {
        // 縦長の画像は縦のサイズを指定値にあわせる
        ratio = image.width / image.height
        width = THUMBNAIL_HEIGHT * ratio
        height = THUMBNAIL_HEIGHT
      }
      canvas.setAttribute('width', width)
      canvas.setAttribute('height', height)

      ctx.clearRect(0, 0, width, height)
      ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height)

      return canvas.toDataURL()
    }
  }
}
</script>
